import React, { Component } from 'react';
import Top_Bar from '../../Part_Sample/Top_Bar';
import { navigateReport } from '../../Common/navigation';
import { isEmpty, isEnergyDevice, isWaterDevice } from '../../Common/Common';
import Target_Cell from './Components/Target_Cell';

export default class Real_Time_Energy_View extends Component {
	constructor(props) {
		super(props);
		let data = {};
		let base64ImageId = null;
		let base64Image = null;
		let targetCell = [];

		window.app.showLoading();

		if (!isEmpty(this.props.param.data)) data = this.props.param.data;

		if (!isEmpty(this.props.param.layout)) {
			if (this.props.param.layout.hasOwnProperty('BGImage')) {
				if (!isEmpty(this.props.param.layout.BGImage)) base64ImageId = this.props.param.layout.BGImage;

				if (base64ImageId != null && base64ImageId != 'null') {
					window.app.showLoading();
					this.props.receiver.loadImage({ name: base64ImageId });
				}
			}

			if (this.props.param.layout.hasOwnProperty('target')) {
				if (!isEmpty(this.props.param.layout.target)) {
					targetCell = this.props.param.layout.target;
				}
			}
		} else {
			window.app.hideLoading();
		}

		this.state = {
			data: data,
			time: new Date(),
			base64ImageId: base64ImageId,
			base64Image: base64Image,
			targetCell: targetCell,
		}

		this.getTime();
	}

	handlePrevious = () => {
		window.app.content_area.current.switch_content.current.handleShowBottomMenu();
		navigateReport("null");
	}

	rcvRealtimeEnergyCos = (data) => {
		let new_data = JSON.parse(JSON.stringify(this.state.data));
		let targetCellTemp = JSON.parse(JSON.stringify(this.state.targetCell));

		for (let id in data) {
			new_data[id].month = data[id].month;
			new_data[id].day = data[id].day;
			new_data[id].hour = data[id].hour;
			new_data[id].daily[data[id].date_index] = new_data[id].day;
			new_data[id].hourly[data[id].hour_index] = new_data[id].hour;
		}

		this.setState({ data: new_data, targetCell: [] }, () => {
			this.setState({ targetCell: targetCellTemp });
		})
	}

	getTime = () => {
		this.setState({ time: new Date() })
		let timeout = setTimeout(this.getTime, 500);
	}

	rcvLoadImage(result) {
		if (result.hasOwnProperty('data')) {
			let imageString = result.data;

			this.setState({
				base64Image: imageString
			});
		} else {
			if (result.hasOwnProperty('result')) {
				if (result.result == 'NG') {
					window.app.showToast(this.props.receiver.getString('load_image_failed'), 3000);
				}
			}
		}
		window.app.hideLoading();
	}

	render() {
		let main_content_style = {
			position: 'fixed',
			//top: 0,
			width: '100%',
			textAlign: 'right',
			height: this.props.height - 68,
			display: 'inline-block',
			overflow: 'auto'
		}

		return (
			<div>
				<div style={main_content_style} className='slideInDown'>
					<img style={{ position: 'absolute', display: this.state.base64Image == null ? 'none' : 'block' }} src={this.state.base64Image} />
					{this.state.targetCell && this.state.targetCell.map((targetInfo, index) => {
						return (
							<Target_Cell
								key={index}
								index={index}
								height={this.props.height}
								width={this.props.width}
								target_info={targetInfo}
								data={this.state.data}
								report_settings={this.props.param.report_settings}
								is_movable={false}
								receiver={this.props.receiver}
							/>
						)
					})}
				</div>
			</div>
		)
	}
}